import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Avatar from '../../components/avatar/Avatar';
import LoaderProjectCard from '../../project/project-flat-card/LoaderProjectCard';
import { formatMoneyKr } from '../../utils';
import { Link } from 'react-router';
import { SectionTitle } from '../../components/typography/Heading';
import styles from './top-three-organizations.module.less';

const fetchOrganizationsWithHighestCollectedAmountLastMonth = async ({ baseUrl }) => {
    const fullUrl = `${baseUrl}/api/public/organization/top-three-organizations`;
    return fetch(fullUrl);
};

const TopThreeOrganizations = () => {
    const baseUrl = useSelector((state) => state.baseURL);
    const [organizations, setOrganizations] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const asyncFetch = async () => {
            try {
                const response = await fetchOrganizationsWithHighestCollectedAmountLastMonth({ baseUrl });
                if (response.status === 200) {
                    const organizationsResponse = await response.json();
                    setOrganizations(organizationsResponse);
                }
                setLoading(false);
            } catch (e) {
                setLoading(false);
            }
        };
        asyncFetch();
    }, [baseUrl]);

    if (!loading && organizations.length === 0) {
        return null;
    }

    if (loading) {
        return (
            <section className={styles.campaignsContainer}>
                <SectionTitle tag="h2" className={styles.subTitle}>
                    Topp 3 organisasjoner siste måned
                </SectionTitle>
                <ul className={styles.listContainer}>
                    <li key={1}>
                        <LoaderProjectCard />
                    </li>
                    <li key={2}>
                        <LoaderProjectCard />
                    </li>
                    <li key={3}>
                        <LoaderProjectCard />
                    </li>
                </ul>
            </section>
        );
    }

    return (
        <section className={styles.campaignsContainer}>
            <SectionTitle tag="h2" className={styles.subTitle}>
                Topp 3 organisasjoner siste måned
            </SectionTitle>
            <ul className={styles.listContainer}>
                {organizations.map((organization, index) => (
                    <li key={organization.id}>
                        <Link to={`/org/${organization.id}`} className={styles.listElement}>
                            <Avatar imageSrc={organization.img_url} size="l" className={styles.organizationImage} />
                            <div className={styles.organizationText}>
                                <div className={styles.organizationName}>{organization.name}</div>
                                <div className={styles.organizationResult}>
                                    <div>{formatMoneyKr(organization.collectedAmount)} samlet inn</div>
                                </div>
                            </div>
                        </Link>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default TopThreeOrganizations;
